import React from 'react';
import { connect } from 'react-redux';
import Checkbox from 'crehana-ui/Checkbox';
import Text from 'crehana-ui/Text';
import { primaryMain } from 'crehana-ui/styles/colors';
import LevelEsencialVertical from 'crehana-icons/LevelEsencialVertical';
import LevelIntermediateVertical from 'crehana-icons/LevelIntermediateVertical';
import LevelCompleteVertical from 'crehana-icons/LevelCompleteVertical';
import LevelCompleteCircle from 'crehana-icons/LevelCompleteCircle';
import { toggleFilterLevel } from '../../../redux/actions';

import { ItemWrapper } from '../styles';

type SubItem = {
  slug: string;
  id: number;
  name: string;
  disabled: boolean;
};

type Props = {
  levels: {
    id: string;
    name: string;
    subItems: {
      [key: string]: SubItem;
    };
  };
  levelsSelected: string;
  toggleFilterLevel(params: { subItemId: number }): void;
};

class Levels extends React.Component<Props> {
  onClickLevel = ({ level }: { level: SubItem }) => () => {
    this.props.toggleFilterLevel({ subItemId: level.id });
  };

  renderImage = name => {
    switch (name) {
      case 'Esencial':
        return <LevelEsencialVertical size={24} color={primaryMain} />;
      case 'Intermedio':
        return <LevelIntermediateVertical size={24} color={primaryMain} />;
      case 'Avanzado':
        return <LevelCompleteVertical size={24} color={primaryMain} />;
      case 'Completo':
        return <LevelCompleteCircle size={24} color={primaryMain} />;
      default:
        return null;
    }
  };

  render() {
    const { levels, levelsSelected } = this.props;
    const levelsArray = Object.keys(levels.subItems).map(
      level => levels.subItems[level],
    );

    return levelsArray.map(level => {
      const isSelected = !!levelsSelected[level.id];

      return (
        <ItemWrapper
          key={level.id}
          style={{ opacity: level.disabled ? 0.3 : 1 }}
          onClick={level.disabled ? null : this.onClickLevel({ level })}
        >
          <div className="flex items-center">
            {this.renderImage(level.name)}
            <Text style={{ marginLeft: 8 }} type="body2">
              {level.name}
            </Text>
          </div>
          <Checkbox
            checked={isSelected}
            error={false}
            wrapperProps={{
              onClick: e => {
                e.preventDefault();
              },
            }}
          />
        </ItemWrapper>
      );
    });
  }
}

const mapStateToProps = state => ({
  levels: state.filters.levels,
  levelsSelected: state.filters.levelsSelected,
});

export default connect(
  mapStateToProps,
  { toggleFilterLevel },
)(Levels);
